// extracted by mini-css-extract-plugin
export default {"title":"AnnouncementDetails_title__MsEh2","subTitle":"AnnouncementDetails_subTitle__jcng4","description":"AnnouncementDetails_description__eOiu4"};